import { render, staticRenderFns } from "./NavbarLogo.vue?vue&type=template&id=5f52bd9d&scoped=true&lang=pug"
import script from "./NavbarLogo.vue?vue&type=script&lang=js"
export * from "./NavbarLogo.vue?vue&type=script&lang=js"
import style0 from "./NavbarLogo.vue?vue&type=style&index=0&id=5f52bd9d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52bd9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f52bd9d')) {
      api.createRecord('5f52bd9d', component.options)
    } else {
      api.reload('5f52bd9d', component.options)
    }
    module.hot.accept("./NavbarLogo.vue?vue&type=template&id=5f52bd9d&scoped=true&lang=pug", function () {
      api.rerender('5f52bd9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/navigation/NavbarLogo.vue"
export default component.exports